import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translation_tw from "./tw.json";
import translation_cn from "./cn.json";

const resources = {
  tw: {
    translation: translation_tw,
  },
  cn: {
    translation: translation_cn,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "tw",
    // keySeparator: false, // we do not use keys in form messages.welcome
    // header.slogan
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
